import httpService from "./httpService";

const DashboardApi = {
  //@info below given will be the get the phase according to roleid 
    getAllPhaseList: (limit, page, roleid, sort='') =>
    httpService.get("phaseList", {
      params: {
        ...(limit ? { limit } : {}),
        ...(sort ? { sortByLatestSubject:true } : {}),
        page,
        roleid,
      },
    }),
    
    // @info This is for dashboard counts and recent activity.
    getDashboardData: () =>
    httpService.get("dashboard"),

getAllRecentActivityList: (page,limit)=> httpService.get(`getRecentActivity`, {
      params: {
        ...(limit ? { limit } : {}),
        page
      },
    }),
};
export default DashboardApi;
